import { TPathSource } from '../features/Surveys/types';

export function createPathUri(goalId: string, source: TPathSource, pathId?: string) {
  return pathId ? `/session/${goalId}/${source}/${pathId}` : `/session/${goalId}/${source}`;
}